import React, { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { Box } from '@mui/material';
import { useKeyboard } from '../context/KeyboardContext';
import { useSession } from '../contexts/SessionContext';
import KioskIdError from './KioskIdError';

// Page titles for different routes
const pageTitles = {
  '/shop': 'Donations, Events & Services',
  '/cart': 'Your Cart',
  '/checkout': 'Checkout',
  '/payment': 'Payment',
  '/confirmation': 'Order Confirmation'
};

const AppLayout = () => {
  const location = useLocation();
  const title = pageTitles[location.pathname] || '';
  const kb = useKeyboard();
  const { session } = useSession();

  // Close virtual keyboard and blur focus on every route change
  useEffect(() => {
    try { kb?.close && kb.close(); } catch {}
    try { kb?.suppress && kb.suppress(800); } catch {}
    try {
      if (document && document.activeElement && document.activeElement.blur) {
        document.activeElement.blur();
      }
    } catch {}
  }, [location.pathname]);
  
  return (
    <Box sx={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
      {/* Display error if kioskId is missing */}
      <KioskIdError kioskId={session?.kioskId} currentUrl={window.location.href} />

      <Box 
        component="main" 
        sx={{ 
          flexGrow: 1, 
          p: 0,
          maxWidth: '100%',
          width: '100%',
          margin: '0 auto',
          boxSizing: 'border-box'
        }}
      >
        <Outlet />
      </Box>
    </Box>
  );
};

export default AppLayout;
